import type { LDClient } from "launchdarkly-js-client-sdk";

import { FLAGS } from "./registry";

let ldClientRef: LDClient | null = null;

export function registerLaunchDarklyClient(client: LDClient | null) {
  ldClientRef = client ?? null;
}

export function ldBoolVariation(key: string, defaultValue = false): boolean {
  try {
    if (!ldClientRef || typeof ldClientRef.variation !== "function") {
      return defaultValue;
    }
    return Boolean(ldClientRef.variation(key, defaultValue));
  } catch {
    return defaultValue;
  }
}

export function eng1121CacheResultsEnabled(): boolean {
  const def = FLAGS.ENG_1121_CACHE_RESULTS_COUNT;
  return ldBoolVariation(def.key, def.defaultValue);
}

export function eng1241CaseInsensitiveParamsEnabled(): boolean {
  const def = FLAGS.ENG_1241_CASE_INSENSITIVE_PARAMS;
  return ldBoolVariation(def.key, def.defaultValue);
}
